import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

function Chip({ label, text, className }) {
  return (
    <div
      className={`animate-float-soft absolute rounded-xl border border-ink/5 bg-white/85 px-4 py-3 shadow-lg shadow-lav-soft/60 backdrop-blur-md ${className}`}
    >
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-blush-deep">{label}</p>
      <p className="mt-0.5 font-display text-sm text-ink">{text}</p>
    </div>
  );
}

export default function ProductVisual({ image = "/journal-cover.png", chips = true, className = "" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [24, -24]);
  const yChips = useTransform(scrollYProgress, [0, 1], [10, -14]);

  return (
    <div ref={ref} data-testid="product-visual" className={`relative ${className}`}>
      <div className="absolute left-1/2 top-1/2 h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-lav-soft blur-3xl" />
      <div className="absolute left-1/2 top-1/2 h-[45%] w-[45%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blush-soft blur-3xl animate-breathe" />
      <motion.div style={{ y }} className="relative mx-auto w-3/4 max-w-sm">
        <div className="overflow-hidden rounded-2xl shadow-2xl shadow-lav-deep/20 ring-1 ring-ink/5 [transform:rotate(-2deg)]">
          <img
            src={image}
            alt="In Your Corner Healthcare — Mini Patient Healthcare Journal cover"
            className="h-auto w-full object-cover"
            loading="eager"
          />
        </div>
      </motion.div>
      {chips && (
        <motion.div style={{ y: yChips }} className="absolute inset-0">
          <Chip label="Inside the journal" text="Questions for My Doctor" className="left-0 top-[12%] max-w-[190px]" />
          <Chip label="Symptom tracker" text="Date · Symptom · Severity" className="bottom-[10%] right-0 max-w-[180px]" />
        </motion.div>
      )}
    </div>
  );
}
